import React from "react"
import { badgeType } from "../../../constans/enumTypes"



interface BadgeProps {
    title: string,
    badgeClassName?: string,
    typeBadge: badgeType
}

const Badge: React.FC<BadgeProps> = ({title, badgeClassName = null, typeBadge = badgeType.success}) => {
    const handleTypeBadge = (value: badgeType):string =>  {
        switch (value) {
            case badgeType.success:
                return "text-green-800 bg-green-100"
            case badgeType.error:
                return "text-red-800 bg-red-100"
            case badgeType.warning:
                return "text-amber-800 bg-amber-100"
            case badgeType.info:
                return "text-blue-800 bg-blue-100"
            default:
                return "text-gray-800 bg-gray-100"
        }
    }

    return (
        <span
            className={`inline-flex px-2 text-xs font-semibold leading-5 ${handleTypeBadge(typeBadge)} rounded-full ${badgeClassName ?? null}`}>{title}</span>
    )
}

export default Badge